import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IgeneralResponse03 } from '../app/Interfaces/igeneralresponse02';
import { iStock, stock } from '../app/Interfaces/ipas';
import { GRReport } from '../app/Interfaces/iReport';
import { GetStockValued } from '../app/Interfaces/iStock';
import { environment } from '../environments/environment';
import { DataService } from '../services/data.service';

@Injectable({ providedIn: 'root' })
export class StockService {
  //private storage: any;

  customerID: number = 0;
  customerName: string = "";
  baseUrl = environment.urlAPI;

  constructor(private http: HttpClient, private dataService: DataService) { }

  UpFileStock(File: FormData) {
    try {
      let url = this.baseUrl + 'api/inventory/v1/upfileinventory/';
      return this.dataService.post<IgeneralResponse03>(url, File)
        .pipe(res => {
          return res
        });
    }
    catch (e) {
      console.log("Error");
    }
  }

  getStockV1(Data: stock) {
    try {
      let url = this.baseUrl + 'api/inventory/v1/stock/';
      return this.dataService.put<iStock>(url,Data)
        .pipe(res => {
          return res
        });
    }
    catch (e) {
      console.log("Error");
    }
  }

  getStockValued(p_Par: GetStockValued ) {
    try {
      let url = this.baseUrl + 'api/pas/stockvalued/report';
      return this.dataService.put<GRReport>(url,p_Par)
        .pipe(res => {
          return res
        });
    }
    catch (e) {
      console.log("Error");
    }
  }

  getStockValuedCsv(p_Par: GetStockValued) {
    try
    {
      let url = this.baseUrl + 'api/pas/stockvalued/csv/' + p_Par.CCId + '/' + p_Par.Name + '/' + p_Par.Code + '/' + p_Par.StockStatus;
      return this.http.get(url, { reportProgress: true, observe: 'events', responseType: 'blob' });
    }
    catch (e) {
      console.log("Error");
    }
  }

}
